<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeaderV2
        :title="title"
        :items="items"
        :subTitle="subTitle"
        hasBreadcrumb
        class="mc-page-three"
      />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <McButtonBack class="d-inline-block me-2" />
        <McButton
          variant="primary"
          :text="$t('global.addField')"
          icon="icon-fill_plus"
          @click="$router.push({ name: 'Create Fleet Task Expense' })"
          class="d-inline-block"
        />
      </div>
    </div>
    <McTable
      withCard
      searchable
      stickyHeader
      bulkDeleteApi
      hasEmit:deleteError
      hasCheckbox
      hasDelete
      :hasSelectAll="false"
      :fields="fields"
      :apiClient="apiClient"
      :customHandlers="customHandlers"
      @deleteError="handleDeleteError"
    >
      <template #before-table="{ isSelected, showDeleteModal }">
        <div class="d-flex justify-content-end mb-3">
          <div class="d-flex gap-2">
            <McButton
              v-if="isSelected"
              @click="showDeleteModal"
              variant="secondary-red"
              :text="$t('global.delete')"
              icon="icon-outline_trash"
            />
          </div>
        </div>
      </template>
      <!-- created on -->
      <template #cell(created_on)="{ value }">
        <div>{{ formatIndexDate(value).date }}</div>
        <div class="mc-datetime">{{ formatIndexDate(value).time }}</div>
      </template>
      <!-- updated on -->
      <template #cell(updated_on)="{ value }">
        <template v-if="value">
          <div>{{ formatIndexDate(value).date }}</div>
          <div class="mc-datetime">{{ formatIndexDate(value).time }}</div>
        </template>
        <div v-else>-</div>
      </template>
    </McTable>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import McButton from '@/components/McButton'
import PageHeaderV2 from '@/components/page-header-v2.vue'
import McTable from '@/components/McTable'
import { formatIndexDate } from '@/helpers/tzDate'
import { fields } from './lib/fields/fleetTaskExpenseList'
import * as TemplateExpense from '@/services/rest-api/lib/template/fleet-task-expense/main'
import errorMessageList from './lib/constants/error-message-mapper'
import { errorMessage } from '@/helpers/errorHandler'
import McButtonBack from '@/components/McButtonBack'

export default {
  page: {
    title: 'Template',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeaderV2,
    McButton,
    McTable,
    McButtonBack,
  },
  data() {
    return {
      title: this.$t('setting.homePage.fleetTaskCost'),
      subTitle: this.$t('setting.homePage.textFleetTaskCost'),
      fields,
      params: {},
      metadata: null,
    }
  },
  computed: {
    apiClient() {
      const getTemplateExpense = TemplateExpense.get(
        null,
        this.handleSetParams,
        this.handleSetMetadata
      )
      return {
        get: getTemplateExpense,
        delete: TemplateExpense.deleteMany,
      }
    },
    customHandlers() {
      return {
        handleClickRow: this.handleClickRow,
      }
    },
    items() {
      return [
        {
          text: 'Pengaturan',
          to: '/setting',
        },
        {
          text: 'Template',
          to: '/subsetting',
        },
        {
          text: this.title,
        },
      ]
    },
  },
  methods: {
    formatIndexDate,
    handleClickRow(item) {
      this.$router.push({ name: 'Detail Fleet Task Expense', params: { id: item.id } })
    },
    handleSetParams(params) {
      this.params = params
    },
    handleSetMetadata(metadata) {
      this.metadata = metadata
    },
    handleDeleteError(errors) {
      this.$mcToast.error(errorMessage(errorMessageList[errors.message]))
    },
  },
}
</script>
